<template>
    <div v-cloak>
        <div class="panel">
            <div class="panel-heading">
                <div class="panel-title">
                    <span class="title">
                        <b>Editar Merchandising</b>

                        <i class="fa fa-archive" style="float:right;margin-top:6px;font-size:21px;"></i>
                    </span>

                    <hr class="m-t-md">
                </div>
            </div>
            <div class="panel-body">
                <form id="form">
                    <div class="row form-group" >
                        <div class="col-md-6">
                            <label for="name">Nome do Merchandising</label>
                            <input type="text" class="form-control" name="name" v-model="material.name" id="name">
                        </div>
                    </div>

                    <hr class="m-t-md m-b-md">

                    <div class="row form-group">
                        <div class="col-md-6">
                            <div class="block">
                                <label for="cover_photo">Foto de Capa</label>
                                <input type="file" name="cover_photo" id="cover_photo">
                            </div>
                            <div class="block m-t-md">
                                <img :src="material.cover_photo" width="135px">
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="block">
                                <label for="attachment">Anexo</label>
                                <input type="file" name="attachment" id="attachment">
                            </div>
                            <div class="block m-t-md">
                                <img :src="material.attachment" width="135px">
                            </div>
                        </div>
                    </div>

                    <hr class="m-t-md m-b-md">

                    <div class="row" v-if="loadedCategories">
                        <div class="col-md-12">
                            <label for="categories">Categoria</label>
                            <select name="categories[]" id="categories" size="6" v-model="material.categories" multiple>
                                <option v-for="category in categories" :value="category.id">
                                    {{ category.name }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <hr class="m-t-md m-b-md">

                    <div class="row" v-if="loadedProducts">
                        <div class="col-md-12">
                            <label for="products">Produtos Associados</label>
                            <select id="products" v-model="material.products" multiple>
                                <option v-for="product in products" :value="product.product_id">
                                    {{ product.name }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <hr class="m-t-md m-b-md">

                    <div class="row" v-if="loadedRecipes">
                        <div class="col-md-12">
                            <label for="recipes">Receitas Associados</label>
                            <select name="recipes[]" id="recipes" v-model="material.recipes" multiple>
                                <option v-for="recipe in recipes" :value="recipe.recipe_id">
                                    {{ recipe.name }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <hr>

                    <div class="row" style="font-size:15px;">
                        <div class="col-md-12">
                            <div class="block">
                                <input type="checkbox" value="1" v-model="material.festivals"> Festival
                            </div>
                            <div class="block">
                                <input type="checkbox" value="1" v-model="material.made_in_bakery"> Feito na Padaria
                            </div>
                            <div class="block">
                                <input type="checkbox" value="1" v-model="material.is_post"> Post
                            </div>
                        </div>
                    </div>

                    <div class="block text-right">
                        <router-link to="/exposition" class="btn btn-info m-r-sm">
                            <i class="fa fa-arrow-left"></i> Voltar
                        </router-link>
                        <a class="btn btn-success" @click="save">
                            Salvar <i class="fa fa-save"></i>
                        </a>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                material: {
                    id: '',
                    name: '',
                    cover_photo: '',
                    attachment: '',
                    products: [],
                    recipes: [],
                    categories: [],
                    festivals: '',
                    made_in_bakery: '',
                    is_post: ''
                },
                products: [],
                recipes: [],
                categories: [],
                types: [],
                loadedCategories: false,
                loadedProducts: false,
                loadedRecipes: false,
                errors: undefined,
            }
        },
        methods: {
            save: function(){
                const api = this.$store.state.api + 'material/' + this.$route.params.id;
                const self = this;

                let form           = new FormData();
                let products       = [];
                let recipes        = [];
                let categories     = [];
                let festivals      = this.material.festivals;
                festivals          = (festivals ? 1 : 0);
                let made_in_bakery = this.material.made_in_bakery;
                made_in_bakery     = (made_in_bakery ? 1 : 0);
                let is_post = this.material.is_post;
                is_post     = (is_post ? 1 : 0);

                $('#products').find(':selected').each(function(){
                    products.push($(this).val());
                });

                $('#recipes').find(':selected').each(function(){
                    recipes.push($(this).val());
                });

                $('#categories').find(':selected').each(function(){
                    categories.push($(this).val());
                });

                let coverPhoto = document.getElementById('cover_photo').files[0];
                coverPhoto     = (coverPhoto) ? coverPhoto : '';

                let attachment = document.getElementById('attachment').files[0];
                attachment     = (attachment) ? attachment : '';

                form.append('name', this.material.name);
                form.append('material_type_id', 4);
                form.append('coverPhoto', coverPhoto);
                form.append('attachment', attachment);
                form.append('products', products);
                form.append('recipes', recipes);
                form.append('categories', categories);
                form.append('festivals', festivals);
                form.append('made_in_bakery', made_in_bakery);
                form.append('is_post', is_post);

                self.$http.post(api, form)
                    .then((response) => {
                        this.$message('Sucesso', `Material atualizado com sucesso`, 'success');
                    })
                    .catch((error) => {
                        self.errors = error.response.data;

                        if(typeof self.errors === 'object'){
                            let html = '<ul>';

                            $.each(self.errors, function(key, value){
                                html += '<li class="m-t-sm m-b-sm">' + value[0] + '</li>';
                            });

                            html += '</ul>';

                            self.errors = html;
                        }

                        self.$message(null, self.errors, 'error');
                    });
            },
            getProducts: function(){
                const api = this.$store.state.api + 'product?paginated=false';
                const self = this;

                return self.$http.get(api);
            },
            getRecipes: function(){
                const api = this.$store.state.api + 'recipe?paginated=false';
                const self = this;

                return self.$http.get(api);
            },
            getCategories: function(){
                const api = this.$store.state.api + 'materialCategory?paginated=false';
                const self = this;

                return self.$http.get(api);
            },
            getTypes: function(){
                const api = this.$store.state.api + 'materialType?paginated=false';
                const self = this;

                return self.$http.get(api);
            },
            getProductsArray: function(data){
                $.each(data, function(key, value){
                    data[key] = value.product_id;
                });

                return data;
            },
            getRecipesArray: function(data){
                $.each(data, function(key, value){
                    data[key] = value.recipe_id;
                });

                return data;
            },
            getCategoriesArray: function(data){
                $.each(data, function(key, value){
                    data[key] = value.material_category_id;
                });

                return data;
            },
            updateSelect: function(){
                $('#recipes').bootstrapDualListbox('refresh',    true);
                $('#categories').bootstrapDualListbox('refresh', true);
                $('#products').bootstrapDualListbox('refresh',   true);
            }
        },
        mounted: function(){
            const self = this;
            const id   = self.$route.params.id;
            const api  = self.$store.state.api;

            self.getCategories()
                .then((response) => {
                    self.categories = response.data.data;

                    self.loadedCategories = true;
                })
                .then(() => {
                    let categories = $('#categories');

                    categories.bootstrapDualListbox();
                    categories.ready(function(){
                        categories.bootstrapDualListbox('refresh', true);
                    });
                })
                .catch((error) => {
                    self.errors = error.response.data.errors;
                    self.$message(null, 'Ocorreu um erro ao buscar as Categorias de Materiais', 'error');
                });

            self.getProducts()
                .then((response) => {
                    self.products = response.data.data;

                    self.loadedProducts = true;
                })
                .then(() => {
                    let products = $('#products');

                    products.bootstrapDualListbox();
                    products.ready(function(){
                        products.bootstrapDualListbox('refresh', true);
                    });
                })
                .catch((error) => {
                    self.errors = error.response.data.errors;
                    self.$message(null, 'Ocorreu um erro ao buscar os Produtos', 'error');
                });

            self.getRecipes()
                .then((response) => {
                    self.recipes = response.data.data;

                    self.loadedRecipes = true;
                })
                .then(() => {
                    let recipes = $('#recipes');

                    recipes.bootstrapDualListbox();
                    recipes.ready(function(){
                        recipes.bootstrapDualListbox('refresh', true);
                    });
                })
                .catch((error) => {
                    self.errors = error.response.data.errors;
                    self.$message(null, 'Ocorreu um erro ao buscar as Receitas', 'error');
                });

            self.getTypes()
                .then((response) => {
                    self.types = response.data.data;
                })
                .catch((error) => {
                    self.$message(null, 'Ocorreu um erro ao buscar os Tipos de Materiais', 'error');
                });

            self.$http.get(api + 'material/' + id)
                .then((response) => {
                    self.material = response.data;

                    self.material.products   = self.getProductsArray(response.data.material_products);
                    self.material.recipes    = self.getRecipesArray(response.data.material_recipes);
                    self.material.categories = self.getCategoriesArray(response.data.categories);

                    self.loaded = true;
                })
                .then(() => {
                    self.updateSelect();
                })
        },
        beforeDestroy: function(){
            $('#categories').bootstrapDualListbox('destroy',true);
            $('#products').bootstrapDualListbox('destroy',  true);
            $('#recipes').bootstrapDualListbox('destroy',   true);
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Exposition/Edit.vue